import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-row justify-content-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, "Невозможно создать отчет, т.к. для выбранной даты уже есть отчет", -1)
const _hoisted_3 = { class: "border rounded bg-white px-3 py-3" }
const _hoisted_4 = { class: "d-flex flex-row align-items-center" }
const _hoisted_5 = { class: "me-4 mb-0" }
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = { class: "border rounded bg-white px-3 py-3 mt-3" }
const _hoisted_8 = { class: "mb-3 d-flex flex-row align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "2. Заполните заказы", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Добавить ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Тип услуги")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Клиент")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Сумма нал.")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Сумма б/нал.")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("К-во клинеров")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Список заказов пуст")
const _hoisted_17 = { class: "border rounded bg-white px-3 py-3 mt-3" }
const _hoisted_18 = { class: "mb-3 d-flex flex-row align-items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "3. Переделки", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Добавить ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("Тип услуги")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Клиент")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("К-во клинеров")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("Список переделок пуст")
const _hoisted_25 = { class: "border rounded bg-white px-3 py-3 mt-3" }
const _hoisted_26 = { class: "mb-3 d-flex flex-row align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-0" }, "4. Заполните доп. отчеты", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Добавить ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Тип")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Данные")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Сумма")
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Нет записей")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Доп. информация")
const _hoisted_34 = { class: "border rounded bg-white px-3 py-3 mt-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-4" }, "5. Итог", -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Сумма нал.")
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Сумма б/нал.")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Сумма общая")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Баланс кассы")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Заказы")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Уборка")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("Уборка выезд мастера")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Уборка такси")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Химчистка")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Уборка выезд мастера")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Химчистка такси")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Переделки")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Переделки такси")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Переделки возврат в кассу")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Переделки выплата клинерам")
const _hoisted_55 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_56 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_57 = /*#__PURE__*/_createTextVNode("Доп. отчеты")
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Закуп")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("Внесено в кассу")
const _hoisted_60 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_61 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_62 = /*#__PURE__*/_createTextVNode("Другие затраты")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Итог")
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Общая касса")
const _hoisted_65 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Инкасация")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Остаток в кассе")
const _hoisted_70 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_72 = ["innerHTML"]
const _hoisted_73 = { class: "mt-4 mb-5" }
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" Сохранить ")
const _hoisted_75 = /*#__PURE__*/_createTextVNode(" Сохранить как финальную ")
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" Данные ")
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Клинера ")
const _hoisted_78 = { class: "mb-3" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode("Вид услуги")
const _hoisted_80 = ["selected"]
const _hoisted_81 = ["selected"]
const _hoisted_82 = ["selected"]
const _hoisted_83 = /*#__PURE__*/_createTextVNode("Клиент")
const _hoisted_84 = { class: "d-flex flex-row mt-1 mb-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_86 = { class: "mb-3" }
const _hoisted_87 = /*#__PURE__*/_createTextVNode("Сумма нал.")
const _hoisted_88 = {
  key: 0,
  class: "d-flex flex-row mt-1"
}
const _hoisted_89 = { class: "mb-3" }
const _hoisted_90 = /*#__PURE__*/_createTextVNode("Сумма б/нал.")
const _hoisted_91 = {
  key: 0,
  class: "d-flex flex-row mt-1"
}
const _hoisted_92 = { class: "d-flex flex-row mt-1" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_94 = { class: "mb-3" }
const _hoisted_95 = /*#__PURE__*/_createTextVNode("Отложено в конверт нал.")
const _hoisted_96 = { class: "mb-3" }
const _hoisted_97 = /*#__PURE__*/_createTextVNode("Отложено в конверт б/нал.")
const _hoisted_98 = /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_99 = { class: "mb-3" }
const _hoisted_100 = /*#__PURE__*/_createTextVNode("Выезд мастера нал.")
const _hoisted_101 = { class: "mb-3" }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("Выезд мастера б/нал.")
const _hoisted_103 = { class: "d-flex flex-row mt-1" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", {
  class: "mb-3",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Такси")
const _hoisted_106 = /*#__PURE__*/_createTextVNode("Сумма нал.")
const _hoisted_107 = /*#__PURE__*/_createTextVNode("Сумма б/нал.")
const _hoisted_108 = /*#__PURE__*/_createTextVNode("Туда")
const _hoisted_109 = /*#__PURE__*/_createTextVNode("Обратно")
const _hoisted_110 = { key: 0 }
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" Добавить ")
const _hoisted_112 = /*#__PURE__*/_createTextVNode("Клинер")
const _hoisted_113 = /*#__PURE__*/_createTextVNode("Заработок")
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Нет записей")
const _hoisted_115 = { key: 1 }
const _hoisted_116 = { class: "mb-3" }
const _hoisted_117 = /*#__PURE__*/_createTextVNode("Клинер")
const _hoisted_118 = ["selected"]
const _hoisted_119 = ["value", "selected"]
const _hoisted_120 = /*#__PURE__*/_createTextVNode(" Укажите клинера ")
const _hoisted_121 = { class: "mt-3" }
const _hoisted_122 = /*#__PURE__*/_createTextVNode("Заработок")
const _hoisted_123 = /*#__PURE__*/_createTextVNode("20%")
const _hoisted_124 = /*#__PURE__*/_createTextVNode("25%")
const _hoisted_125 = /*#__PURE__*/_createTextVNode("40%")
const _hoisted_126 = { class: "mt-4 d-flex flex-row justify-content-end" }
const _hoisted_127 = /*#__PURE__*/_createTextVNode(" Отменить ")
const _hoisted_128 = { class: "ps-3 mb-0" }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { key: 1 }
const _hoisted_131 = { key: 2 }
const _hoisted_132 = { key: 3 }
const _hoisted_133 = { key: 4 }
const _hoisted_134 = { key: 5 }
const _hoisted_135 = { key: 6 }
const _hoisted_136 = /*#__PURE__*/_createTextVNode(" Закрыть ")
const _hoisted_137 = /*#__PURE__*/_createTextVNode(" Данные ")
const _hoisted_138 = /*#__PURE__*/_createTextVNode(" Клинера ")
const _hoisted_139 = { class: "mb-3" }
const _hoisted_140 = /*#__PURE__*/_createTextVNode("Вид услуги")
const _hoisted_141 = ["selected"]
const _hoisted_142 = ["selected"]
const _hoisted_143 = ["selected"]
const _hoisted_144 = /*#__PURE__*/_createTextVNode("Клиент")
const _hoisted_145 = { class: "d-flex flex-row mt-1 mb-3" }
const _hoisted_146 = /*#__PURE__*/_createTextVNode("Такси")
const _hoisted_147 = /*#__PURE__*/_createTextVNode("Сумма нал.")
const _hoisted_148 = /*#__PURE__*/_createTextVNode("Сумма б/нал.")
const _hoisted_149 = /*#__PURE__*/_createTextVNode("Туда")
const _hoisted_150 = /*#__PURE__*/_createTextVNode("Обратно")
const _hoisted_151 = { key: 0 }
const _hoisted_152 = /*#__PURE__*/_createTextVNode(" Добавить ")
const _hoisted_153 = /*#__PURE__*/_createTextVNode("Клинер")
const _hoisted_154 = /*#__PURE__*/_createTextVNode("Заработок")
const _hoisted_155 = /*#__PURE__*/_createTextVNode("Возврат")
const _hoisted_156 = /*#__PURE__*/_createTextVNode("Нет записей")
const _hoisted_157 = { key: 1 }
const _hoisted_158 = { class: "mb-3" }
const _hoisted_159 = /*#__PURE__*/_createTextVNode("Клинер")
const _hoisted_160 = ["selected"]
const _hoisted_161 = ["value", "selected"]
const _hoisted_162 = /*#__PURE__*/_createTextVNode(" Укажите клинера ")
const _hoisted_163 = { class: "mt-3" }
const _hoisted_164 = /*#__PURE__*/_createTextVNode("Заработок")
const _hoisted_165 = { class: "mt-3" }
const _hoisted_166 = /*#__PURE__*/_createTextVNode("Возврат средств в кассу (нал.)")
const _hoisted_167 = { class: "mt-4 d-flex flex-row justify-content-end" }
const _hoisted_168 = /*#__PURE__*/_createTextVNode(" Отменить ")
const _hoisted_169 = { class: "ps-3 mb-0" }
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { key: 1 }
const _hoisted_172 = { key: 2 }
const _hoisted_173 = { key: 3 }
const _hoisted_174 = /*#__PURE__*/_createTextVNode(" Закрыть ")
const _hoisted_175 = { class: "mb-3" }
const _hoisted_176 = /*#__PURE__*/_createTextVNode("Тип отчета")
const _hoisted_177 = ["selected"]
const _hoisted_178 = ["selected", "value"]
const _hoisted_179 = /*#__PURE__*/_createTextVNode(" Укажите тип отчета ")
const _hoisted_180 = { class: "mb-3" }
const _hoisted_181 = /*#__PURE__*/_createTextVNode("Кто внес")
const _hoisted_182 = /*#__PURE__*/_createTextVNode(" Укажите кто внес средства ")
const _hoisted_183 = { class: "mb-3" }
const _hoisted_184 = /*#__PURE__*/_createTextVNode("Сумма нал.")
const _hoisted_185 = /*#__PURE__*/_createTextVNode(" Укажите сумму ")
const _hoisted_186 = /*#__PURE__*/_createTextVNode("Комментарий")
const _hoisted_187 = /*#__PURE__*/_createTextVNode(" Наименование ")
const _hoisted_188 = /*#__PURE__*/_createTextVNode(" Цена ")
const _hoisted_189 = /*#__PURE__*/_createTextVNode(" К-во ")
const _hoisted_190 = /*#__PURE__*/_createTextVNode(" Сумма ")
const _hoisted_191 = /*#__PURE__*/_createTextVNode(" Список наименований пуст ")
const _hoisted_192 = /*#__PURE__*/_createTextVNode(" Укажите наименование ")
const _hoisted_193 = /*#__PURE__*/_createTextVNode(" Укажите цену ")
const _hoisted_194 = { class: "d-flex flex-row mt-2 fs-14" }
const _hoisted_195 = { class: "me-2" }
const _hoisted_196 = /*#__PURE__*/_createTextVNode(" Количество не должно быть меньше или равно нулю ")
const _hoisted_197 = /*#__PURE__*/_createTextVNode(" Добавить ")
const _hoisted_198 = { class: "mb-3" }
const _hoisted_199 = /*#__PURE__*/_createTextVNode("Описание")
const _hoisted_200 = /*#__PURE__*/_createTextVNode(" Поле обязательно для заполнение ")
const _hoisted_201 = { class: "mb-3" }
const _hoisted_202 = /*#__PURE__*/_createTextVNode("Сумма нал.")
const _hoisted_203 = /*#__PURE__*/_createTextVNode(" Укажите сумму наличных или безналичных ")
const _hoisted_204 = /*#__PURE__*/_createTextVNode("Сумма б/нал.")
const _hoisted_205 = /*#__PURE__*/_createTextVNode(" Укажите сумму наличных или безналичных ")
const _hoisted_206 = { class: "ps-3 mb-0" }
const _hoisted_207 = { key: 0 }
const _hoisted_208 = /*#__PURE__*/_createTextVNode(" Закрыть ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CSpinner = _resolveComponent("CSpinner")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CAlert = _resolveComponent("CAlert")!
  const _component_CInputGroupText = _resolveComponent("CInputGroupText")!
  const _component_CFormInput = _resolveComponent("CFormInput")!
  const _component_CInputGroup = _resolveComponent("CInputGroup")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CTableHeaderCell = _resolveComponent("CTableHeaderCell")!
  const _component_CTableRow = _resolveComponent("CTableRow")!
  const _component_CTableHead = _resolveComponent("CTableHead")!
  const _component_CTableDataCell = _resolveComponent("CTableDataCell")!
  const _component_CTableBody = _resolveComponent("CTableBody")!
  const _component_CTable = _resolveComponent("CTable")!
  const _component_CFormLabel = _resolveComponent("CFormLabel")!
  const _component_CFormTextarea = _resolveComponent("CFormTextarea")!
  const _component_CCol = _resolveComponent("CCol")!
  const _component_CRow = _resolveComponent("CRow")!
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_CModalTitle = _resolveComponent("CModalTitle")!
  const _component_CModalHeader = _resolveComponent("CModalHeader")!
  const _component_CNavLink = _resolveComponent("CNavLink")!
  const _component_CNavItem = _resolveComponent("CNavItem")!
  const _component_CNav = _resolveComponent("CNav")!
  const _component_CContainer = _resolveComponent("CContainer")!
  const _component_CFormSelect = _resolveComponent("CFormSelect")!
  const _component_CFormCheck = _resolveComponent("CFormCheck")!
  const _component_CTabPane = _resolveComponent("CTabPane")!
  const _component_CFormFeedback = _resolveComponent("CFormFeedback")!
  const _component_CTabContent = _resolveComponent("CTabContent")!
  const _component_CModalBody = _resolveComponent("CModalBody")!
  const _component_CModalFooter = _resolveComponent("CModalFooter")!
  const _component_CModal = _resolveComponent("CModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_CSpinner)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (!this.reportDateIsAvailable)
            ? (_openBlock(), _createBlock(_component_CAlert, {
                key: 0,
                color: "danger",
                class: "d-flex align-items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CIcon, {
                    icon: "cil-burn",
                    class: "flex-shrink-0 me-2",
                    width: "24",
                    height: "24"
                  }),
                  _hoisted_2
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, " 1. " + _toDisplayString(this.report.id !== null ? "Дата отчета" : "Выберите дату"), 1),
              _createVNode(_component_v_date_picker, {
                locale: "ru",
                class: "inline-block h-full",
                modelValue: _ctx.report.reportDate,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.report.reportDate) = $event))
              }, {
                default: _withCtx(({ inputValue, togglePopover }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_CInputGroup, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_CInputGroupText, {
                          onClick: ($event: any) => (this.report.id === null ? togglePopover() : false)
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CIcon, { icon: "cil-calendar" })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createVNode(_component_CFormInput, {
                          onClick: ($event: any) => (this.report.id === null ? togglePopover() : false),
                          disabled: this.report.id !== null,
                          value: inputValue,
                          onKeydown: _withModifiers(($event: any) => (false), ["prevent"])
                        }, null, 8, ["onClick", "disabled", "value", "onKeydown"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          (_ctx.report.reportDate != null)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_CButton, {
                      size: "sm",
                      color: "primary",
                      class: "ms-3",
                      onClick: _cache[1] || (_cache[1] = () => _ctx.showOrderModal())
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CIcon, { icon: "cil-plus" }),
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_CTable, {
                    hover: _ctx.report.orders.length > 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CTableHead, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CTableRow, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_12
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_14
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableBody, null, {
                        default: _withCtx(() => [
                          (_ctx.report.orders.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.report.orders, (order) => {
                                return (_openBlock(), _createBlock(_component_CTableRow, {
                                  align: "middle",
                                  key: order
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$helpers.orderServiceTypes[order.serviceType]), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(order.client) + " (" + _toDisplayString(_ctx.$helpers.clientTypes[order.clientType]) + ") ", 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(order.sumCash)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(order.sumNonCash)) + " " + _toDisplayString(order.sumNonCash > 0 ? `(${_ctx.$helpers.nonCashTypes[order.nonCashType]})` : ''), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(order.cleaners.length), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, { class: "text-end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CButton, {
                                          color: "success",
                                          onClick: () => _ctx.showOrderModal(order)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CIcon, { icon: "cil-pencil" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_CButton, {
                                          color: "danger",
                                          class: "ms-3",
                                          onClick: () => _ctx.removeOrder(order)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CIcon, { icon: "cil-trash" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_CTableRow, {
                                key: 1,
                                align: "middle"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CTableHeaderCell, {
                                    scope: "row",
                                    colspan: "6",
                                    class: "text-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_16
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["hover"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_CButton, {
                      size: "sm",
                      color: "primary",
                      class: "ms-3",
                      onClick: _cache[2] || (_cache[2] = () => _ctx.showAlterationModal())
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CIcon, { icon: "cil-plus" }),
                        _hoisted_20
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_CTable, {
                    hover: _ctx.report.alterations.length > 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CTableHead, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CTableRow, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_21
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_22
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_23
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableBody, null, {
                        default: _withCtx(() => [
                          (_ctx.report.alterations.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.report.alterations, (alteration) => {
                                return (_openBlock(), _createBlock(_component_CTableRow, {
                                  align: "middle",
                                  key: alteration
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$helpers.orderServiceTypes[alteration.serviceType]), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(alteration.client) + " (" + _toDisplayString(_ctx.$helpers.clientTypes[alteration.clientType]) + ") ", 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(alteration.cleaners.length), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, { class: "text-end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CButton, {
                                          color: "success",
                                          onClick: () => _ctx.showAlterationModal(alteration)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CIcon, { icon: "cil-pencil" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_CButton, {
                                          color: "danger",
                                          class: "ms-3",
                                          onClick: () => _ctx.removeAlteration(alteration)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CIcon, { icon: "cil-trash" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_CTableRow, {
                                key: 1,
                                align: "middle"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CTableHeaderCell, {
                                    scope: "row",
                                    colspan: "4",
                                    class: "text-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_24
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["hover"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _createVNode(_component_CButton, {
                      size: "sm",
                      color: "primary",
                      class: "ms-3",
                      onClick: _cache[3] || (_cache[3] = () => _ctx.showAdditionalReportModal())
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CIcon, { icon: "cil-plus" }),
                        _hoisted_28
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_CTable, {
                    hover: _ctx.report.additionalReports.length > 0
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CTableHead, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CTableRow, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_29
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_30
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                default: _withCtx(() => [
                                  _hoisted_31
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, { scope: "col" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableBody, null, {
                        default: _withCtx(() => [
                          (_ctx.report.additionalReports.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.report.additionalReports, (additionalReport) => {
                                return (_openBlock(), _createBlock(_component_CTableRow, {
                                  align: "middle",
                                  key: additionalReport
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$helpers.additionalReportTypes[additionalReport.type]), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.additionalReportDataInfo(additionalReport)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.additionalReportSum(additionalReport))), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_CTableDataCell, { class: "text-end" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_CButton, {
                                          color: "success",
                                          onClick: () => _ctx.showAdditionalReportModal(additionalReport)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CIcon, { icon: "cil-pencil" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_CButton, {
                                          color: "danger",
                                          class: "ms-3",
                                          onClick: () => _ctx.removeAdditionalReport(additionalReport)
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CIcon, { icon: "cil-trash" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            : (_openBlock(), _createBlock(_component_CTableRow, {
                                key: 1,
                                align: "middle"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CTableHeaderCell, {
                                    colspan: "4",
                                    class: "text-center"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_32
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["hover"]),
                  _createVNode(_component_CRow, { class: "mt-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CCol, { md: "5" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CFormLabel, null, {
                            default: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CFormTextarea, {
                            rows: "3",
                            modelValue: _ctx.report.additionalInfo,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.report.additionalInfo) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_CTable, {
                    bordered: "",
                    hover: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CTableHead, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CTableRow, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, {
                                scope: "col",
                                class: "w-25"
                              }),
                              _createVNode(_component_CTableHeaderCell, {
                                scope: "col",
                                class: "w-25"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_36
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, {
                                scope: "col",
                                class: "w-25"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableHeaderCell, {
                                scope: "col",
                                class: "w-25"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_38
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CTableBody, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_39
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.cashRegisterBalance)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_40
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_41
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableDataCell, {
                                colspan: "4",
                                class: "text-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_42
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_43
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningTotalCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningTotalNonCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningTotalSum)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_44
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningCleanerDepartureTotalCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningCleanerDepartureTotalNonCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningCleanerDepartureTotalSum)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_45
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningTaxiTotalCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningTaxiTotalNonCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersCleaningTaxiTotalSum)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_46
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningTotalCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningTotalNonCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningTotalSum)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_47
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningCleanerDepartureTotalCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningCleanerDepartureTotalNonCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningCleanerDepartureTotalSum)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_48
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningTaxiTotalCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningTaxiTotalNonCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.ordersDryCleaningTaxiTotalSum)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableDataCell, {
                                colspan: "4",
                                class: "text-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_49
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_50
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.alterationTaxiSum({ withCash: true }))), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.alterationTaxiSum({ withNonCash: true }))), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.alterationTaxiSum(
                  { withCash: true, withNonCash: true }
              ))), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_51
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.alterationPuttingMoneySum())), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_52
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_53
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_54
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.alterationCleanersIncomeSum())), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_55
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_56
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableDataCell, {
                                colspan: "4",
                                class: "text-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_57
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_58
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.purchasesCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.purchasesNonCashSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.purchasesTotalSum)), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_59
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.cashRegisterRefillsSum)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_60
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_61
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_62
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.otherSpendingsSum({ withCash: true }))), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.otherSpendingsSum({ withNonCash: true }))), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.otherSpendingsSum(
                    { withCash: true, withNonCash: true }
                ))), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableDataCell, {
                                colspan: "4",
                                class: "text-center"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_63
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_64
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.cashRegisterTotal)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_65
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_66
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_67
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, { colspan: "2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_AppInput, {
                                    modelValue: _ctx.report.encashment,
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.report.encashment) = $event)),
                                    mask: _ctx.$config.currencyMask
                                  }, null, 8, ["modelValue", "mask"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_68
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTableRow, { color: "dark" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                default: _withCtx(() => [
                                  _hoisted_69
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(_ctx.cashRegisterRemainingBalance)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_70
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _hoisted_71
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.validationErrors !== null)
                  ? (_openBlock(), _createBlock(_component_CAlert, {
                      key: 0,
                      color: "danger",
                      class: "d-flex align-items-center mt-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CIcon, {
                          icon: "cil-burn",
                          class: "flex-shrink-0 me-4",
                          width: "24",
                          height: "24"
                        }),
                        _createElementVNode("div", {
                          innerHTML: _ctx.validationErrors.innerHTML
                        }, null, 8, _hoisted_72)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_component_CButton, {
                    color: "primary",
                    class: "me-3",
                    disabled: _ctx.savingLoading,
                    onClick: _cache[6] || (_cache[6] = () => _ctx.saveReport(false))
                  }, {
                    default: _withCtx(() => [
                      (_ctx.savingLoading)
                        ? (_openBlock(), _createBlock(_component_CSpinner, {
                            key: 0,
                            size: "sm",
                            class: "me-2"
                          }))
                        : (_openBlock(), _createBlock(_component_CIcon, {
                            key: 1,
                            icon: "cil-save",
                            class: "me-2"
                          })),
                      _hoisted_74
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_CButton, {
                    color: "primary",
                    disabled: _ctx.savingLoading,
                    onClick: _cache[7] || (_cache[7] = () => _ctx.saveReport(true))
                  }, {
                    default: _withCtx(() => [
                      (_ctx.savingLoading)
                        ? (_openBlock(), _createBlock(_component_CSpinner, {
                            key: 0,
                            size: "sm",
                            class: "me-2"
                          }))
                        : (_openBlock(), _createBlock(_component_CIcon, {
                            key: 1,
                            icon: "cil-save",
                            class: "me-2"
                          })),
                      _hoisted_75
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ], 64))
            : _createCommentVNode("", true)
        ], 64)),
    _createVNode(_component_CModal, {
      visible: _ctx.editOrder !== null,
      onClose: _ctx.onOrderModalClose,
      backdrop: "static"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CModalHeader, null, {
          default: _withCtx(() => [
            _createVNode(_component_CModalTitle, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.editOrder.id === 0
          ? `Добавить заказ`
          : `Редактировать заказ`), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CContainer, {
          class: _normalizeClass(["py-3 modal-pills-header", { 'div-overlay': _ctx.orderModalAddCleanerMode }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CNav, {
              variant: "pills",
              role: "tablist",
              layout: "fill",
              class: "w-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CNavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CNavLink, {
                      href: "javascript:void(0);",
                      active: _ctx.orderModalTabPanelActiveKey === 1,
                      onClick: _cache[8] || (_cache[8] = () => { _ctx.orderModalTabPanelChange(1) })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_76
                      ]),
                      _: 1
                    }, 8, ["active"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_CNavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CNavLink, {
                      href: "javascript:void(0);",
                      active: _ctx.orderModalTabPanelActiveKey === 2,
                      onClick: _cache[9] || (_cache[9] = () => { _ctx.orderModalTabPanelChange(2) })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_77
                      ]),
                      _: 1
                    }, 8, ["active"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_CModalBody, { class: "py-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_CTabContent, null, {
              default: _withCtx(() => [
                _createVNode(_component_CTabPane, {
                  role: "tabpanel",
                  visible: _ctx.orderModalTabPanelActiveKey === 1
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(_component_CFormLabel, null, {
                        default: _withCtx(() => [
                          _hoisted_79
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CFormSelect, {
                        modelValue: _ctx.editOrder.serviceType,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editOrder.serviceType) = $event)),
                        invalid: _ctx.editOrder.serviceTypeInvalid,
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.editOrder.serviceTypeInvalid = false))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", {
                            selected: _ctx.editOrder.serviceType == null,
                            disabled: ""
                          }, "-", 8, _hoisted_80),
                          _createElementVNode("option", {
                            selected: _ctx.editOrder.serviceType === 'cleaning',
                            value: "cleaning"
                          }, "Уборка", 8, _hoisted_81),
                          _createElementVNode("option", {
                            selected: _ctx.editOrder.serviceType === 'dry_cleaning',
                            value: "dry_cleaning"
                          }, "Химчистка", 8, _hoisted_82)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "invalid"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_CFormLabel, null, {
                        default: _withCtx(() => [
                          _hoisted_83
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppInput, {
                        type: "text",
                        invalid: _ctx.editOrder.clientInvalid,
                        onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.editOrder.clientInvalid = false)),
                        modelValue: _ctx.editOrder.client,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.editOrder.client) = $event))
                      }, null, 8, ["invalid", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$helpers.clientTypes, (typeHuman, typeKey) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: typeKey,
                          class: "me-4"
                        }, [
                          _createVNode(_component_CFormCheck, {
                            type: "radio",
                            name: "orderClientType",
                            value: typeKey,
                            invalid: _ctx.editOrder.clientTypeInvalid,
                            id: `orderClientType_${typeKey}`,
                            onInput: _cache[14] || (_cache[14] = ($event: any) => {_ctx.editOrder.clientType = $event.target.value;
                            _ctx.editOrder.clientTypeInvalid = false}),
                            checked: _ctx.editOrder.clientType === typeKey,
                            label: typeHuman
                          }, null, 8, ["value", "invalid", "id", "checked", "label"])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_85,
                    _createElementVNode("div", _hoisted_86, [
                      _createVNode(_component_CFormLabel, null, {
                        default: _withCtx(() => [
                          _hoisted_87
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppInput, {
                        type: "number",
                        invalid: _ctx.editOrder.sumInvalid,
                        onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.editOrder.sumInvalid = false)),
                        mask: _ctx.$config.currencyMask,
                        modelValue: _ctx.editOrder.sumCash,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editOrder.sumCash) = $event))
                      }, null, 8, ["invalid", "mask", "modelValue"]),
                      (_ctx.editOrder.clientType === 'regular')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                            _createVNode(_component_CFormCheck, {
                              id: "editOrderIsCashFromEnvelope",
                              modelValue: _ctx.editOrder.isCashFromEnvelope,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.editOrder.isCashFromEnvelope) = $event)),
                              label: "Из конверта"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_CFormLabel, null, {
                          default: _withCtx(() => [
                            _hoisted_90
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_AppInput, {
                          type: "number",
                          invalid: _ctx.editOrder.sumInvalid,
                          onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.editOrder.sumInvalid = false)),
                          mask: _ctx.$config.currencyMask,
                          modelValue: _ctx.editOrder.sumNonCash,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editOrder.sumNonCash) = $event))
                        }, null, 8, ["invalid", "mask", "modelValue"])
                      ]),
                      (_ctx.editOrder.clientType === 'regular')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createVNode(_component_CFormCheck, {
                              id: "editOrderIsNonCashFromEnvelope",
                              modelValue: _ctx.editOrder.isNonCashFromEnvelope,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editOrder.isNonCashFromEnvelope) = $event)),
                              label: "Из конверта"
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_92, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$helpers.nonCashTypes, (typeHuman, typeKey) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: typeKey,
                            class: "me-4"
                          }, [
                            _createVNode(_component_CFormCheck, {
                              type: "radio",
                              name: "orderNonCashType",
                              value: typeKey,
                              invalid: _ctx.editOrder.nonCashTypeInvalid,
                              id: `orderNonCashType_${typeKey}`,
                              onInput: _cache[21] || (_cache[21] = ($event: any) => {_ctx.editOrder.nonCashType = $event.target.value;
                            _ctx.editOrder.nonCashTypeInvalid = false}),
                              checked: _ctx.editOrder.nonCashType === typeKey,
                              label: typeHuman
                            }, null, 8, ["value", "invalid", "id", "checked", "label"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _hoisted_93,
                    (_ctx.editOrder.clientType === 'regular')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_94, [
                            _createVNode(_component_CFormLabel, null, {
                              default: _withCtx(() => [
                                _hoisted_95
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_AppInput, {
                              type: "number",
                              mask: _ctx.$config.currencyMask,
                              modelValue: _ctx.editOrder.envelopeRefillCash,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editOrder.envelopeRefillCash) = $event))
                            }, null, 8, ["mask", "modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _createVNode(_component_CFormLabel, null, {
                              default: _withCtx(() => [
                                _hoisted_97
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_AppInput, {
                              type: "number",
                              mask: _ctx.$config.currencyMask,
                              modelValue: _ctx.editOrder.envelopeRefillNonCash,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.editOrder.envelopeRefillNonCash) = $event))
                            }, null, 8, ["mask", "modelValue"])
                          ]),
                          _hoisted_98
                        ], 64))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_99, [
                      _createVNode(_component_CFormLabel, null, {
                        default: _withCtx(() => [
                          _hoisted_100
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppInput, {
                        type: "number",
                        invalid: _ctx.editOrder.cleanerDepartureSumInvalid,
                        onInput: _cache[24] || (_cache[24] = ($event: any) => (_ctx.editOrder.cleanerDepartureSumInvalid = false)),
                        mask: _ctx.$config.currencyMask,
                        modelValue: _ctx.editOrder.cleanerDepartureSumCash,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.editOrder.cleanerDepartureSumCash) = $event))
                      }, null, 8, ["invalid", "mask", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_CFormLabel, null, {
                          default: _withCtx(() => [
                            _hoisted_102
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_AppInput, {
                          type: "number",
                          invalid: _ctx.editOrder.cleanerDepartureSumInvalid,
                          onInput: _cache[26] || (_cache[26] = ($event: any) => (_ctx.editOrder.cleanerDepartureSumInvalid = false)),
                          mask: _ctx.$config.currencyMask,
                          modelValue: _ctx.editOrder.cleanerDepartureSumNonCash,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.editOrder.cleanerDepartureSumNonCash) = $event))
                        }, null, 8, ["invalid", "mask", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_103, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$helpers.nonCashTypes, (typeHuman, typeKey) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: typeKey,
                            class: "me-4"
                          }, [
                            _createVNode(_component_CFormCheck, {
                              type: "radio",
                              name: "cleanerDepartureNonCashType",
                              value: typeKey,
                              invalid: _ctx.editOrder.cleanerDepartureNonCashTypeInvalid,
                              id: `cleanerDepartureNonCashType_${typeKey}`,
                              onInput: _cache[28] || (_cache[28] = ($event: any) => {_ctx.editOrder.cleanerDepartureNonCashType = $event.target.value;
                                _ctx.editOrder.cleanerDepartureNonCashTypeInvalid = false}),
                              checked: _ctx.editOrder.cleanerDepartureNonCashType === typeKey,
                              label: typeHuman
                            }, null, 8, ["value", "invalid", "id", "checked", "label"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _hoisted_104,
                    _createVNode(_component_CTable, {
                      hover: "",
                      bordered: "",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CTableHead, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableRow, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                  default: _withCtx(() => [
                                    _hoisted_105
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_106
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_107
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CTableBody, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableRow, { align: "middle" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_108
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editOrder.taxiThere.sumCash,
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.editOrder.taxiThere.sumCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editOrder.taxiThere.sumNonCash,
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.editOrder.taxiThere.sumNonCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CTableRow, { align: "middle" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_109
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editOrder.taxiBack.sumCash,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editOrder.taxiBack.sumCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editOrder.taxiBack.sumNonCash,
                                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.editOrder.taxiBack.sumNonCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode(_component_CTabPane, {
                  role: "tabpanel",
                  visible: _ctx.orderModalTabPanelActiveKey === 2
                }, {
                  default: _withCtx(() => [
                    (_ctx.editOrderCleaner == null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                          _createVNode(_component_CButton, {
                            size: "sm",
                            color: "primary",
                            class: "mb-2",
                            onClick: _cache[33] || (_cache[33] = () => _ctx.showOrderCleanerForm())
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CIcon, { icon: "cil-plus" }),
                              _hoisted_111
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTable, { hover: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHead, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CTableRow, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                        default: _withCtx(() => [
                                          _hoisted_112
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                        default: _withCtx(() => [
                                          _hoisted_113
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_CTableHeaderCell, { scope: "col" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableBody, null, {
                                default: _withCtx(() => [
                                  (_ctx.editOrder.cleaners.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.editOrder.cleaners, (cleaner) => {
                                        return (_openBlock(), _createBlock(_component_CTableRow, {
                                          align: "middle",
                                          key: cleaner
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(cleaner.cleaner.firstName) + " " + _toDisplayString(cleaner.cleaner.lastName), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_CTableDataCell, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(cleaner.income)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_CTableDataCell, { class: "text-end" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_CButton, {
                                                  size: "sm",
                                                  color: "success",
                                                  onClick: () => _ctx.showOrderCleanerForm(cleaner)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_CIcon, { icon: "cil-pencil" })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_CButton, {
                                                  size: "sm",
                                                  color: "danger",
                                                  class: "ms-3",
                                                  onClick: () => _ctx.removeOrderCleaner(cleaner)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_CIcon, { icon: "cil-trash" })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    : (_openBlock(), _createBlock(_component_CTableRow, {
                                        key: 1,
                                        align: "middle"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CTableDataCell, {
                                            colspan: "3",
                                            class: "text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_114
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_115, [
                          _createElementVNode("form", {
                            onSubmit: _cache[38] || (_cache[38] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onOrderCleanerSaveButtonClick && _ctx.onOrderCleanerSaveButtonClick(...args)), ["prevent"]))
                          }, [
                            _createElementVNode("h6", _hoisted_116, _toDisplayString(_ctx.editOrderCleaner.id === 0
                  ? 'Добавление клинера в заказ' : 'Изменение клинера в заказе'), 1),
                            _createElementVNode("div", null, [
                              _createVNode(_component_CFormLabel, null, {
                                default: _withCtx(() => [
                                  _hoisted_117
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CFormSelect, {
                                invalid: _ctx.editOrderCleaner.cleanerInvalid,
                                onInput: _ctx.onOrderCleanerFormCleanChanged
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("option", {
                                    value: "",
                                    selected: _ctx.editOrderCleaner.cleaner === null,
                                    disabled: ""
                                  }, "-", 8, _hoisted_118),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCleaners, (cleaner) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: cleaner,
                                      value: cleaner.id,
                                      selected: _ctx.editOrderCleaner.cleaner?.id === cleaner.id
                                    }, _toDisplayString(cleaner.firstName) + " " + _toDisplayString(cleaner.lastName), 9, _hoisted_119))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["invalid", "onInput"]),
                              _createVNode(_component_CFormFeedback, { invalid: "" }, {
                                default: _withCtx(() => [
                                  _hoisted_120
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_121, [
                              _createVNode(_component_CFormLabel, null, {
                                default: _withCtx(() => [
                                  _hoisted_122
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_AppInput, {
                                type: "number",
                                mask: _ctx.$config.currencyMask,
                                modelValue: _ctx.editOrderCleaner.income,
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.editOrderCleaner.income) = $event))
                              }, null, 8, ["mask", "modelValue"]),
                              _createVNode(_component_CRow, { class: "mt-2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CCol, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CButton, {
                                        type: "button",
                                        size: "sm",
                                        color: "light",
                                        class: "w-100",
                                        onClick: _cache[35] || (_cache[35] = () => _ctx.calculateCleanerIncome(20))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_123
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_CCol, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CButton, {
                                        type: "button",
                                        size: "sm",
                                        color: "light",
                                        class: "w-100",
                                        onClick: _cache[36] || (_cache[36] = () => _ctx.calculateCleanerIncome(25))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_124
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_CCol, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CButton, {
                                        type: "button",
                                        size: "sm",
                                        color: "light",
                                        class: "w-100",
                                        onClick: _cache[37] || (_cache[37] = () => _ctx.calculateCleanerIncome(40))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_125
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_126, [
                              _createVNode(_component_CButton, {
                                type: "button",
                                size: "sm",
                                color: "light",
                                onClick: _ctx.onOrderAddCleanerClose
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_127
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_CButton, {
                                type: "submit",
                                size: "sm",
                                color: "primary",
                                class: "ms-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.editOrderCleaner.id === 0
                    ? 'Добавить клинера' : 'Изменить клинера'), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ], 32)
                        ]))
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CModalFooter, {
          class: _normalizeClass(_ctx.orderModalAddCleanerMode ? 'modal-footer--overlaid' : '')
        }, {
          default: _withCtx(() => [
            (_ctx.editOrderInvalid)
              ? (_openBlock(), _createBlock(_component_CAlert, {
                  key: 0,
                  color: "danger",
                  class: "d-flex w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CIcon, {
                      icon: "cil-burn",
                      class: "flex-shrink-0 me-2",
                      width: "24",
                      height: "24"
                    }),
                    _createElementVNode("div", null, [
                      _createElementVNode("ul", _hoisted_128, [
                        (_ctx.editOrder.serviceTypeInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_129, "Укажите тип услуги"))
                          : _createCommentVNode("", true),
                        (_ctx.editOrder.clientInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_130, "Введите данные клиента"))
                          : _createCommentVNode("", true),
                        (_ctx.editOrder.clientTypeInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_131, "Укажите тип клиента"))
                          : _createCommentVNode("", true),
                        (_ctx.editOrder.sumInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_132, "Введите сумму наличных и/или сумму безналичных"))
                          : _createCommentVNode("", true),
                        (_ctx.editOrder.nonCashTypeInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_133, " Выберите тип безналичной оплаты"))
                          : _createCommentVNode("", true),
                        (_ctx.editOrder.cleanersInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_134, "Добавьте хотя бы одного клинера"))
                          : _createCommentVNode("", true),
                        (_ctx.editOrder.cleanerDepartureNonCashTypeInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_135, " Выберите тип безналичной оплаты для суммы выезда мастера"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_CButton, {
              color: "light",
              onClick: _ctx.onOrderModalClose
            }, {
              default: _withCtx(() => [
                _hoisted_136
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_CButton, {
              color: "primary",
              onClick: _ctx.onSaveOrderButtonClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.editOrder.id === 0 ? 'Добавить заказ' : 'Изменить заказ'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_CModal, {
      visible: _ctx.editAlteration !== null,
      onClose: _ctx.onAlterationModalClose,
      backdrop: "static"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CModalHeader, null, {
          default: _withCtx(() => [
            _createVNode(_component_CModalTitle, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.editAlteration.id === 0
          ? `Добавить переделку`
          : `Редактировать переделку`), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CContainer, {
          class: _normalizeClass(["py-3 modal-pills-header", { 'div-overlay': _ctx.alterationModalAddCleanerMode }])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CNav, {
              variant: "pills",
              role: "tablist",
              layout: "fill",
              class: "w-100"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CNavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CNavLink, {
                      href: "javascript:void(0);",
                      active: _ctx.alterationModalTabPanelActiveKey === 1,
                      onClick: _cache[39] || (_cache[39] = () => { _ctx.alterationModalTabPanelChange(1) })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_137
                      ]),
                      _: 1
                    }, 8, ["active"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_CNavItem, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CNavLink, {
                      href: "javascript:void(0);",
                      active: _ctx.alterationModalTabPanelActiveKey === 2,
                      onClick: _cache[40] || (_cache[40] = () => { _ctx.alterationModalTabPanelChange(2) })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_138
                      ]),
                      _: 1
                    }, 8, ["active"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_CModalBody, { class: "py-4" }, {
          default: _withCtx(() => [
            _createVNode(_component_CTabContent, null, {
              default: _withCtx(() => [
                _createVNode(_component_CTabPane, {
                  role: "tabpanel",
                  visible: _ctx.alterationModalTabPanelActiveKey === 1
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_139, [
                      _createVNode(_component_CFormLabel, null, {
                        default: _withCtx(() => [
                          _hoisted_140
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_CFormSelect, {
                        modelValue: _ctx.editAlteration.serviceType,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.editAlteration.serviceType) = $event)),
                        invalid: _ctx.editAlteration.serviceTypeInvalid,
                        onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.editAlteration.serviceTypeInvalid = false))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("option", {
                            selected: _ctx.editAlteration.serviceType == null,
                            disabled: ""
                          }, "-", 8, _hoisted_141),
                          _createElementVNode("option", {
                            selected: _ctx.editAlteration.serviceType === 'cleaning',
                            value: "cleaning"
                          }, "Уборка", 8, _hoisted_142),
                          _createElementVNode("option", {
                            selected: _ctx.editAlteration.serviceType === 'dry_cleaning',
                            value: "dry_cleaning"
                          }, "Химчистка", 8, _hoisted_143)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "invalid"])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_CFormLabel, null, {
                        default: _withCtx(() => [
                          _hoisted_144
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_AppInput, {
                        type: "text",
                        invalid: _ctx.editAlteration.clientInvalid,
                        onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.editAlteration.clientInvalid = false)),
                        modelValue: _ctx.editAlteration.client,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.editAlteration.client) = $event))
                      }, null, 8, ["invalid", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$helpers.clientTypes, (typeHuman, typeKey) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: typeKey,
                          class: "me-4"
                        }, [
                          _createVNode(_component_CFormCheck, {
                            type: "radio",
                            name: "alterationClientType",
                            value: typeKey,
                            invalid: _ctx.editAlteration.clientTypeInvalid,
                            id: `alterationClientType_${typeKey}`,
                            onInput: _cache[45] || (_cache[45] = ($event: any) => {_ctx.editAlteration.clientType = $event.target.value;
                            _ctx.editAlteration.clientTypeInvalid = false}),
                            checked: _ctx.editAlteration.clientType === typeKey,
                            label: typeHuman
                          }, null, 8, ["value", "invalid", "id", "checked", "label"])
                        ]))
                      }), 128))
                    ]),
                    _createVNode(_component_CTable, {
                      hover: "",
                      bordered: "",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CTableHead, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableRow, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                  default: _withCtx(() => [
                                    _hoisted_146
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_147
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_148
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CTableBody, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableRow, { align: "middle" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_149
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editAlteration.taxiThere.sumCash,
                                      "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.editAlteration.taxiThere.sumCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editAlteration.taxiThere.sumNonCash,
                                      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.editAlteration.taxiThere.sumNonCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CTableRow, { align: "middle" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _hoisted_150
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editAlteration.taxiBack.sumCash,
                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.editAlteration.taxiBack.sumCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_CTableDataCell, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_AppInput, {
                                      type: "number",
                                      mask: _ctx.$config.currencyMask,
                                      modelValue: _ctx.editAlteration.taxiBack.sumNonCash,
                                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.editAlteration.taxiBack.sumNonCash) = $event))
                                    }, null, 8, ["mask", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["visible"]),
                _createVNode(_component_CTabPane, {
                  role: "tabpanel",
                  visible: _ctx.alterationModalTabPanelActiveKey === 2
                }, {
                  default: _withCtx(() => [
                    (_ctx.editAlterationCleaner == null)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                          _createVNode(_component_CButton, {
                            size: "sm",
                            color: "primary",
                            class: "mb-2",
                            onClick: _cache[50] || (_cache[50] = () => _ctx.showAlterationCleanerForm())
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CIcon, { icon: "cil-plus" }),
                              _hoisted_152
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_CTable, { hover: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableHead, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CTableRow, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                        default: _withCtx(() => [
                                          _hoisted_153
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                        default: _withCtx(() => [
                                          _hoisted_154
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_CTableHeaderCell, { scope: "col" }, {
                                        default: _withCtx(() => [
                                          _hoisted_155
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_CTableHeaderCell, { scope: "col" })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CTableBody, null, {
                                default: _withCtx(() => [
                                  (_ctx.editAlteration.cleaners.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.editAlteration.cleaners, (cleaner) => {
                                        return (_openBlock(), _createBlock(_component_CTableRow, {
                                          align: "middle",
                                          key: cleaner
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_CTableHeaderCell, { scope: "row" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(cleaner.name), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_CTableDataCell, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(cleaner.income)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_CTableDataCell, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(cleaner.puttingMoney)), 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_CTableDataCell, { class: "text-end" }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_CButton, {
                                                  size: "sm",
                                                  color: "success",
                                                  onClick: () => _ctx.showAlterationCleanerForm(cleaner)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_CIcon, { icon: "cil-pencil" })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_CButton, {
                                                  size: "sm",
                                                  color: "danger",
                                                  class: "ms-3",
                                                  onClick: () => _ctx.removeAlterationCleaner(cleaner)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_CIcon, { icon: "cil-trash" })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    : (_openBlock(), _createBlock(_component_CTableRow, {
                                        key: 1,
                                        align: "middle"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_CTableDataCell, {
                                            colspan: "3",
                                            class: "text-center"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_156
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_157, [
                          _createElementVNode("form", {
                            onSubmit: _cache[53] || (_cache[53] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onAlterationCleanerSaveButtonClick && _ctx.onAlterationCleanerSaveButtonClick(...args)), ["prevent"]))
                          }, [
                            _createElementVNode("h6", _hoisted_158, _toDisplayString(_ctx.editAlterationCleaner.id === 0
                  ? 'Добавление клинера в переделку' : 'Изменение клинера в переделке'), 1),
                            _createElementVNode("div", null, [
                              _createVNode(_component_CFormLabel, null, {
                                default: _withCtx(() => [
                                  _hoisted_159
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_CFormSelect, {
                                invalid: _ctx.editAlterationCleaner.cleanerInvalid,
                                onInput: _ctx.onAlterationCleanerFormCleanChanged
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("option", {
                                    value: "",
                                    selected: _ctx.editAlterationCleaner.cleaner === null,
                                    disabled: ""
                                  }, "-", 8, _hoisted_160),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCleaners, (cleaner) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: cleaner,
                                      value: cleaner.id,
                                      selected: _ctx.editAlterationCleaner.cleaner?.id === cleaner.id
                                    }, _toDisplayString(cleaner.firstName) + " " + _toDisplayString(cleaner.lastName), 9, _hoisted_161))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["invalid", "onInput"]),
                              _createVNode(_component_CFormFeedback, { invalid: "" }, {
                                default: _withCtx(() => [
                                  _hoisted_162
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_163, [
                              _createVNode(_component_CFormLabel, null, {
                                default: _withCtx(() => [
                                  _hoisted_164
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_AppInput, {
                                type: "number",
                                mask: _ctx.$config.currencyMask,
                                modelValue: _ctx.editAlterationCleaner.income,
                                "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.editAlterationCleaner.income) = $event))
                              }, null, 8, ["mask", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_165, [
                              _createVNode(_component_CFormLabel, null, {
                                default: _withCtx(() => [
                                  _hoisted_166
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_AppInput, {
                                type: "number",
                                mask: _ctx.$config.currencyMask,
                                modelValue: _ctx.editAlterationCleaner.puttingMoney,
                                "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.editAlterationCleaner.puttingMoney) = $event))
                              }, null, 8, ["mask", "modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_167, [
                              _createVNode(_component_CButton, {
                                type: "button",
                                size: "sm",
                                color: "light",
                                onClick: _ctx.onAlterationAddCleanerClose
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_168
                                ]),
                                _: 1
                              }, 8, ["onClick"]),
                              _createVNode(_component_CButton, {
                                type: "submit",
                                size: "sm",
                                color: "primary",
                                class: "ms-2"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.editAlterationCleaner.id === 0
                    ? 'Добавить клинера' : 'Изменить клинера'), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ], 32)
                        ]))
                  ]),
                  _: 1
                }, 8, ["visible"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CModalFooter, {
          class: _normalizeClass(_ctx.alterationModalAddCleanerMode ? 'modal-footer--overlaid' : '')
        }, {
          default: _withCtx(() => [
            (_ctx.editAlterationInvalid)
              ? (_openBlock(), _createBlock(_component_CAlert, {
                  key: 0,
                  color: "danger",
                  class: "d-flex w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CIcon, {
                      icon: "cil-burn",
                      class: "flex-shrink-0 me-2",
                      width: "24",
                      height: "24"
                    }),
                    _createElementVNode("div", null, [
                      _createElementVNode("ul", _hoisted_169, [
                        (_ctx.editAlteration.serviceTypeInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_170, "Укажите тип услуги"))
                          : _createCommentVNode("", true),
                        (_ctx.editAlteration.clientInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_171, "Введите данные клиента"))
                          : _createCommentVNode("", true),
                        (_ctx.editAlteration.clientTypeInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_172, "Укажите тип клиента"))
                          : _createCommentVNode("", true),
                        (_ctx.editAlteration.cleanersInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_173, "Добавьте хотя бы одного клинера"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_CButton, {
              color: "light",
              onClick: _ctx.onAlterationModalClose
            }, {
              default: _withCtx(() => [
                _hoisted_174
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_CButton, {
              color: "primary",
              onClick: _ctx.onSaveAlterationButtonClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.editAlteration.id === 0 ? 'Добавить переделку' : 'Изменить переделку'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_CModal, {
      visible: _ctx.editAdditionalReport !== null,
      onClose: _ctx.onAdditionalReportModalClose,
      backdrop: "static"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CModalHeader, null, {
          default: _withCtx(() => [
            _createVNode(_component_CModalTitle, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.editAdditionalReport.id === 0
          ? `Добавить доп. отчет`
          : `Редактировать доп. отчет`), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_CModalBody, { class: "py-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_175, [
              _createVNode(_component_CFormLabel, null, {
                default: _withCtx(() => [
                  _hoisted_176
                ]),
                _: 1
              }),
              _createVNode(_component_CFormSelect, {
                onChange: _cache[54] || (_cache[54] = ($event: any) => (_ctx.onAdditionalReportTypeChanged($event.target.value))),
                disabled: _ctx.editAdditionalReport.id !== 0,
                invalid: _ctx.editAdditionalReport.typeInvalid
              }, {
                default: _withCtx(() => [
                  _createElementVNode("option", {
                    selected: _ctx.editAdditionalReport.type == null,
                    disabled: ""
                  }, "-", 8, _hoisted_177),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$helpers.additionalReportTypes, (typeHuman, typeKey) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: typeKey,
                      selected: _ctx.editAdditionalReport.type === typeKey,
                      value: typeKey
                    }, _toDisplayString(typeHuman), 9, _hoisted_178))
                  }), 128))
                ]),
                _: 1
              }, 8, ["disabled", "invalid"]),
              _createVNode(_component_CFormFeedback, { invalid: "" }, {
                default: _withCtx(() => [
                  _hoisted_179
                ]),
                _: 1
              })
            ]),
            (_ctx.editAdditionalReport.type === 'putting_money')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_180, [
                    _createVNode(_component_CFormLabel, null, {
                      default: _withCtx(() => [
                        _hoisted_181
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_CFormInput, {
                      type: "text",
                      invalid: _ctx.editAdditionalReport.data.performerInvalid,
                      onInput: _cache[55] || (_cache[55] = ($event: any) => (_ctx.editAdditionalReport.data.performerInvalid = false)),
                      modelValue: _ctx.editAdditionalReport.data.performer,
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.editAdditionalReport.data.performer) = $event))
                    }, null, 8, ["invalid", "modelValue"]),
                    _createVNode(_component_CFormFeedback, { invalid: "" }, {
                      default: _withCtx(() => [
                        _hoisted_182
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_183, [
                    _createVNode(_component_CFormLabel, null, {
                      default: _withCtx(() => [
                        _hoisted_184
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AppInput, {
                      type: "number",
                      invalid: _ctx.editAdditionalReport.data.sumCashInvalid,
                      onInput: _cache[57] || (_cache[57] = ($event: any) => (_ctx.editAdditionalReport.data.sumCashInvalid = false)),
                      mask: _ctx.$config.currencyMask,
                      modelValue: _ctx.editAdditionalReport.data.sumCash,
                      "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.editAdditionalReport.data.sumCash) = $event))
                    }, null, 8, ["invalid", "mask", "modelValue"]),
                    _createVNode(_component_CFormFeedback, { invalid: "" }, {
                      default: _withCtx(() => [
                        _hoisted_185
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_CFormLabel, null, {
                      default: _withCtx(() => [
                        _hoisted_186
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_CFormTextarea, {
                      rows: "3",
                      modelValue: _ctx.editAdditionalReport.data.comment,
                      "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.editAdditionalReport.data.comment) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.editAdditionalReport.type === 'purchase')
              ? (_openBlock(), _createBlock(_component_CTable, {
                  key: 1,
                  bordered: "",
                  hover: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CTableHead, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_CTableRow, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableHeaderCell, {
                              scope: "col",
                              class: "additional-report-table-col-name"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_187
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CTableHeaderCell, {
                              scope: "col",
                              class: "additional-report-table-col-price"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_188
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CTableHeaderCell, {
                              scope: "col",
                              class: "additional-report-table-col-quantity"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_189
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CTableHeaderCell, {
                              scope: "col",
                              class: "additional-report-table-col-sum"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_190
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_CTableHeaderCell, {
                              scope: "col",
                              class: "additional-report-table-col-action"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_CTableBody, null, {
                      default: _withCtx(() => [
                        (_ctx.editAdditionalReport.data.items.length === 0)
                          ? (_openBlock(), _createBlock(_component_CTableRow, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CTableHeaderCell, {
                                  colspan: "5",
                                  class: "text-center fs-14"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_191
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editAdditionalReport.data.items, (purchaseItem, purchaseIndex) => {
                          return (_openBlock(), _createBlock(_component_CTableRow, { key: purchaseItem }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_AppInput, {
                                    type: "text",
                                    size: "sm",
                                    invalid: purchaseItem.nameInvalid,
                                    onInput: ($event: any) => (purchaseItem.nameInvalid = false),
                                    modelValue: purchaseItem.name,
                                    "onUpdate:modelValue": ($event: any) => ((purchaseItem.name) = $event)
                                  }, null, 8, ["invalid", "onInput", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_CFormFeedback, { invalid: "" }, {
                                    default: _withCtx(() => [
                                      _hoisted_192
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_AppInput, {
                                    type: "number",
                                    size: "sm",
                                    invalid: purchaseItem.priceInvalid,
                                    onInput: ($event: any) => (purchaseItem.priceInvalid = false),
                                    mask: _ctx.$config.currencyMask,
                                    modelValue: purchaseItem.price,
                                    "onUpdate:modelValue": ($event: any) => ((purchaseItem.price) = $event)
                                  }, null, 8, ["invalid", "onInput", "mask", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_CFormFeedback, { invalid: "" }, {
                                    default: _withCtx(() => [
                                      _hoisted_193
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("div", _hoisted_194, [
                                    _createElementVNode("div", _hoisted_195, [
                                      _createVNode(_component_CFormCheck, {
                                        type: "radio",
                                        name: `purchase_sum_type_${
                                _ctx.editAdditionalReport.id}_${purchaseIndex}`,
                                        value: "cash",
                                        id: `purchaseSumType_${
                                _ctx.editAdditionalReport.id}_${purchaseIndex}Cash`,
                                        onInput: ($event: any) => (purchaseItem.priceType = $event.target.value),
                                        checked: purchaseItem.priceType === 'cash',
                                        label: "Нал."
                                      }, null, 8, ["name", "id", "onInput", "checked"])
                                    ]),
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_CFormCheck, {
                                        type: "radio",
                                        name: `purchase_sum_type_${
                                _ctx.editAdditionalReport.id}_${purchaseIndex}`,
                                        value: "non_cash",
                                        id: `purchaseSumType_${
                                _ctx.editAdditionalReport.id}_${purchaseIndex}NonCash`,
                                        onInput: ($event: any) => (purchaseItem.priceType = $event.target.value),
                                        checked: purchaseItem.priceType === 'non_cash',
                                        label: "Б/нал."
                                      }, null, 8, ["name", "id", "onInput", "checked"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_AppInput, {
                                    type: "number",
                                    size: "sm",
                                    invalid: purchaseItem.quantityInvalid,
                                    onInput: ($event: any) => (purchaseItem.quantityInvalid = false),
                                    mask: _ctx.$config.numberMask,
                                    modelValue: purchaseItem.quantity,
                                    "onUpdate:modelValue": ($event: any) => ((purchaseItem.quantity) = $event)
                                  }, null, 8, ["invalid", "onInput", "mask", "modelValue", "onUpdate:modelValue"]),
                                  _createVNode(_component_CFormFeedback, { invalid: "" }, {
                                    default: _withCtx(() => [
                                      _hoisted_196
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$helpers.formatCurrency(purchaseItem.price * purchaseItem.quantity)), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_CTableDataCell, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CButton, {
                                    size: "sm",
                                    color: "danger",
                                    onClick: () => _ctx.removeAdditionalReportPurchaseItem(purchaseIndex)
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CIcon, { icon: "cil-trash" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_CTableHead, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_CTableRow, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_CTableDataCell, { colspan: "5" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CButton, {
                                  size: "sm",
                                  color: "primary",
                                  onClick: _ctx.addAdditionalReportPurchaseItem
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_CIcon, { icon: "cil-plus" }),
                                    _hoisted_197
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.editAdditionalReport.type === 'other')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_198, [
                    _createVNode(_component_CFormLabel, null, {
                      default: _withCtx(() => [
                        _hoisted_199
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_CFormTextarea, {
                      type: "text",
                      invalid: _ctx.editAdditionalReport.data.descriptionInvalid,
                      onInput: _cache[60] || (_cache[60] = ($event: any) => (_ctx.editAdditionalReport.data.descriptionInvalid = false)),
                      modelValue: _ctx.editAdditionalReport.data.description,
                      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.editAdditionalReport.data.description) = $event))
                    }, null, 8, ["invalid", "modelValue"]),
                    _createVNode(_component_CFormFeedback, { invalid: "" }, {
                      default: _withCtx(() => [
                        _hoisted_200
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_201, [
                    _createVNode(_component_CFormLabel, null, {
                      default: _withCtx(() => [
                        _hoisted_202
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AppInput, {
                      type: "number",
                      invalid: _ctx.editAdditionalReport.data.sumInvalid,
                      onInput: _cache[62] || (_cache[62] = ($event: any) => (_ctx.editAdditionalReport.data.sumInvalid = false)),
                      mask: _ctx.$config.currencyMask,
                      modelValue: _ctx.editAdditionalReport.data.sumCash,
                      "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.editAdditionalReport.data.sumCash) = $event))
                    }, null, 8, ["invalid", "mask", "modelValue"]),
                    _createVNode(_component_CFormFeedback, { invalid: "" }, {
                      default: _withCtx(() => [
                        _hoisted_203
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_CFormLabel, null, {
                      default: _withCtx(() => [
                        _hoisted_204
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_AppInput, {
                      type: "number",
                      invalid: _ctx.editAdditionalReport.data.sumInvalid,
                      onInput: _cache[64] || (_cache[64] = ($event: any) => (_ctx.editAdditionalReport.data.sumInvalid = false)),
                      mask: _ctx.$config.currencyMask,
                      modelValue: _ctx.editAdditionalReport.data.sumNonCash,
                      "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.editAdditionalReport.data.sumNonCash) = $event))
                    }, null, 8, ["invalid", "mask", "modelValue"]),
                    _createVNode(_component_CFormFeedback, { invalid: "" }, {
                      default: _withCtx(() => [
                        _hoisted_205
                      ]),
                      _: 1
                    })
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_CModalFooter, null, {
          default: _withCtx(() => [
            (_ctx.editAdditionalReportInvalid)
              ? (_openBlock(), _createBlock(_component_CAlert, {
                  key: 0,
                  color: "danger",
                  class: "d-flex w-100"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CIcon, {
                      icon: "cil-burn",
                      class: "flex-shrink-0 me-2",
                      width: "24",
                      height: "24"
                    }),
                    _createElementVNode("div", null, [
                      _createElementVNode("ul", _hoisted_206, [
                        (_ctx.editAdditionalReport.data.itemsInvalid)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_207, " Отчет о закупке должен содержать хотя бы одно наименование "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_CButton, {
              color: "light",
              onClick: _ctx.onAdditionalReportModalClose
            }, {
              default: _withCtx(() => [
                _hoisted_208
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_CButton, {
              color: "primary",
              onClick: _ctx.onSaveAdditionalReportButtonClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.editAdditionalReport.id === 0 ? 'Добавить доп. отчет' : 'Изменить доп. отчет'), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "onClose"])
  ], 64))
}